/**
 * A room drawn as a round table: one dot per seat, coloured by the group the
 * seat is reserved for (or filled by). Open seats are hollow; a reserved seat
 * nobody could fill is dashed. Pure SVG, sized by `size` px.
 *
 *   seats: [{ color, state: 'filled' | 'open' | 'missing', label }]
 */
function SeatRing({ seats, size = 120, center }) {
    const r = size / 2;
    const count = Math.max(seats.length, 1);
    const seatR = Math.max(4, Math.min(size / 9, (Math.PI * (r - 10)) / count - 2));
    const orbit = r - seatR - 2;

    return (
        <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} role="img" aria-label={`${seats.length} seats`}>
            <circle cx={r} cy={r} r={orbit - seatR - 4} fill="var(--bg-secondary)" stroke="var(--border-color-soft)" />
            {center != null && (
                <text x={r} y={r} textAnchor="middle" dominantBaseline="central"
                    style={{ fill: 'var(--text-secondary)', fontSize: Math.max(10, size / 7), fontWeight: 600 }}>
                    {center}
                </text>
            )}
            {seats.map((seat, i) => {
                const a = (i / count) * Math.PI * 2 - Math.PI / 2;
                const cx = r + orbit * Math.cos(a);
                const cy = r + orbit * Math.sin(a);
                const filled = seat.state === 'filled';
                return (
                    <circle
                        key={i}
                        cx={cx}
                        cy={cy}
                        r={seatR}
                        fill={filled ? seat.color : 'var(--bg-primary)'}
                        stroke={seat.color}
                        strokeWidth={filled ? 0 : 2}
                        strokeDasharray={seat.state === 'missing' ? '3 2' : undefined}
                    >
                        {seat.label && <title>{seat.label}</title>}
                    </circle>
                );
            })}
        </svg>
    );
}

export default SeatRing;
